import { render, staticRenderFns } from "./bellPopper.vue?vue&type=template&id=05ea0e7a&scoped=true&"
import script from "./bellPopper.vue?vue&type=script&lang=js&"
export * from "./bellPopper.vue?vue&type=script&lang=js&"
import style0 from "./bellPopper.vue?vue&type=style&index=0&id=05ea0e7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ea0e7a",
  null
  
)

export default component.exports